import { toast } from '@breezeventures/ui-kit/toast';

export const showErrorToast = (error: Error) => {
  toast(error.message || 'Request failed. Please try again.', {
    type: 'error',
    duration: 5000,
    dismissible: true,
    position: 'top-right',
  });
};
